module.exports = __webpack_public_path__ + "img/222929.e17e9187.png";